/* eslint-disable */
import axios from '@/plugins/axios'
import io from "@/plugins/socket";
import vue from 'vue'

const state = {
  stats:[],
  stats_data:{
    categories:[],
    series:[{
      name:'Выплачено',
      data:[]
    }]
  },
  stats_query:{
    email:null,
    directions:[],
    role:[]
  },
  payout:[],
  payout_days:[],
  payroll:[],
  payroll_months:[]
}

const getters = {
  currentDay: state => day => {
    if( state.payout.length )
      return state.payout.some(d => d.date === day)
  },
  currentMonth: state => month => {
    if( state.payroll.length )
      return state.payroll.some(d => d.date === month)
  },
  counter: state => type => {
    if( state.payout.length )
      return state.payout.map(f => parseInt(f[type]) ).reduce((acc,v) => acc + (v || 0) )
  },
  counterPayroll: state => {
    if( state.payroll.length )
      return state.payroll.map(f => parseInt(f['payroll']) ).reduce((acc,v) => acc + (v || 0) )
  }
  
}
const actions = {
  async getPayout({ commit }){
    try {
      const { data } = await axios.get('/finance/payout')
      if( !data.payload ) $notify({ type:'error', text: data.error })
      else commit('setPayout', data.payload )
    } catch (e){ $notify({ type:'error', text: e })}
  },
  async getPayroll({ commit }){
    try {
      const { data } = await axios.get('/finance/payroll')
      if( !data.payload ) $notify({ type:'error', text: data.error })
      else commit('setPayroll', data.payload )
    } catch (e){ $notify({ type:'error', text: e })}
  },
  async getPayoutByDay({ commit }, payload){
    commit('setPayout', {last:[]} )
    try {
      const { data } = await axios.post('/finance/payout', payload) // date
      if( !data.payload ) $notify({ type:'error', text: data.error })
      else commit('setPayout', data.payload )
    } catch (e){ $notify({ type:'error', text: data.error })}
  },
  async getPayrollByMonth({ commit }, payload){
    commit('setPayroll', {last:[]} )
    try {
      const { data } = await axios.post('/finance/payroll', payload) // date
      if( !data.payload ) $notify({ type:'error', text: data.error })
      else commit('setPayroll', data.payload )
    } catch (e){ $notify({ type:'error', text: data.error })}
  },
  async addPayoutDate({ commit }, payload){
    try {
      io.emit('FINANCE_PAYOUT_ADDDAY', payload)
    }
    catch (e){ $notify({ type:'error', text: e })}
  },
  async addPayrollMonth({ commit }, payload){
    try {
      io.emit('FINANCE_PAYROLL_ADDMONTH', payload)
      $notify({ type:'success', message: 'finance_dayadd_success' })
    }
    catch (e){ $notify({ type:'error', text: e })}
  },
  async getUserStats({ commit }){
    try {
      const { data } = await axios.get('/finance/stats')
      if( data.payload ) commit('setStatsData', data.payload)
      else $notify({ type:'error', text: data.error })
    }
    catch (e){ $notify({ type:'error', text: e })}
  },
  addUsersPayroll({}, payload){
    try {
      io.emit('FINANCE_PAYROLL_ADDUSERS', payload);
      
      $notify({ type:'success', message: 'update_success' })
    }
    catch (e){ $notify({ type:'error', text: e })}
  },
  removeUserPayroll({}, payload){
    try {
      io.emit('FINANCE_PAYROLL_REMOVE_USER', payload);
      
      $notify({ type:'success', message: 'update_success' })
    }
    catch (e){ $notify({ type:'error', text: e })}
  },
	addUsersPayout({}, payload){
		try {
			io.emit('FINANCE_PAYOUT_ADDUSERS', payload);
			
			$notify({ type:'success', message: 'update_success' })
		}
		catch (e){ $notify({ type:'error', text: e })}
	},
	removeUserPayout({}, payload){
		try {
			io.emit('FINANCE_PAYOUT_REMOVE_USER', payload);
			
			$notify({ type:'success', message: 'update_success' })
		}
		catch (e){ $notify({ type:'error', text: e })}
	},
  updatePayout({commit},payload){
    try {
      io.emit('FINANCE_PAYOUT_UPDATE', payload)
      $notify({ type:'success', message: 'update_success' })
    }
    catch (e){ $notify({ type:'error', text: e })}
  },
  updatePayroll({commit},payload){
    try {
      io.emit('FINANCE_PAYROLL_UPDATE', payload)
      $notify({ type:'success', message: 'update_success' })
    }
    catch (e){ $notify({ type:'error', text: e })}
  },
  removePayoutDate({ commit },payload){
    try { io.emit('FINANCE_PAYOUT_REMOVE_DAY', payload) }
    catch (e){ $notify({ type:'error', text: e })}
  },
  removePayrollMonth({ commit },payload){
    try { io.emit('FINANCE_PAYROLL_REMOVE_MONTH', payload) }
    catch (e){ $notify({ type:'error', text: e })}
  },
  
  async getStatsData({ commit, state }){
    try {
      const { data } = await axios.post('/finance/stats', state.stats_query )
      if( data.payload ) commit('setStatsData', data.payload)
      else $notify({ type:'error', text: data.error })
    }
    catch (e){ $notify({ type:'error', text: e })}
    
  },
  setStatsQuery({commit}, payload){
    commit('setStatsQuery', payload)
  }
}
const mutations = {
  setStatsQuery(state, payload){
    state.stats_query = Object.assign(state.stats_query, payload)
  },
  setUserStats(state,payload){
    state.stats = payload.stats//.slice().sort((a,b)=> a.date - b.date)
  },
  setStatsData(state,payload){
    state.stats_data = payload.stats_data
    state.stats = payload.stats
    
  },
  setPayout(state,payload){
    state.payout = payload.last
    if( payload.days ) state.payout_days = payload.days
  },
  setPayroll(state,payload){
    state.payroll = payload.last
    if( payload.months ) state.payroll_months = payload.months
  },
  updateDate(state, payload){
    if(!state.payout_days.some(d => d === payload.date)) state.payout_days.unshift(payload.date)
  },
  updateMonth(state, payload){
    if(!state.payroll_months.some(d => d.date === payload.date)) state.payroll_months.push(payload)
  },
  updatePayout(state, payload){
    if( state.payout.some(p => p.date === payload.date)){
      const index = state.payout.findIndex(p => p.owner === payload.owner);
      if( index > -1) vue.set(state.payout, index, Object.assign(state.payout[ index ], payload))
    }
  },
  updatePayroll(state, payload){
    if( state.payroll.some(p => p.date === payload.date)){
      const index = state.payroll.findIndex(p => p.owner === payload.owner);
      if( index > -1) vue.set(state.payroll, index, Object.assign(state.payroll[ index ], payload))
    }
  },
  removePayoutDate(state, payload){
    const index = state.payout_days.findIndex(p => p === payload.date);
    if( index > -1) {
      state.payout_days.splice(index, 1)
      $notify({ type:'success', message: 'remove_success' })
    }
    
  },
  removePayrollMonth(state, payload){
    const index = state.payroll_months.findIndex(p => p.date === payload.date);
    if( index > -1) {
      
      state.payroll_months.splice(index, 1)
      $notify({ type:'success', message: 'remove_success' })
    }
  },
  removeUserFromPayroll(state,payload){
    try {
      const index = state.payroll.findIndex(p => p.owner === payload.owner)
      if( index > -1 ) state.payroll.splice(index, 1)
    }
    catch (e){void e}
  },
	removeUserFromPayout(state,payload){
		try {
			const index = state.payout.findIndex(p => p.owner === payload.owner)
			if( index > -1 ) state.payout.splice(index, 1)
		}
		catch (e){void e}
	},
  addUserToPayroll(state,payload){
    try {
      if( state.payroll[0].date === payload.month ){
        for(const u of payload.users){
          if( !state.payroll.some(p => p.owner === u.email) ) state.payroll.push(u)
        }
      }
    }
    catch (e){ void e }
  },
	addUserToPayout(state,payload){
		try {
			if( state.payout[0].date === payload.day ){
				for(const u of payload.users){
					const payout =  {
						payout: 0,
						cashout: 0,
						cardout: 0,
						date: payload.day,
						owner: u.email
					}
					if( !state.payout.some(p => p.owner === u.email) ) state.payout.push(payout)
				}
			}
		}
		catch (e){ void e }
	}
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}